import React from 'react';

/**
 * SearchBar - Reusable search input component with magnifying glass icon
 * 
 * @param {Object} props - Component props
 * @param {string} props.value - Current search value
 * @param {Function} props.onChange - Called when search value changes
 * @param {string} [props.placeholder='Search...'] - Input placeholder text
 * @param {string} [props.iconSize='0.9rem'] - Size of the search icon
 * @param {string} [props.iconLeft='1rem'] - Left position of the search icon
 * @param {string} [props.iconTop='50%'] - Top position of the search icon
 * @param {string} [props.inputPaddingLeft='2.5rem'] - Left padding of the input
 * @param {Object} [props.style={}] - Additional styles for the container
 * @param {Object} [props.inputStyle={}] - Additional styles for the input
 * @returns {React.ReactElement} Search bar component
 */
const SearchBar = ({
  value,
  onChange,
  placeholder = 'Search...',
  iconSize = '0.9rem',
  iconLeft = '1rem',
  iconTop = '50%',
  inputPaddingLeft = '2.5rem',
  style = {},
  inputStyle = {}
}) => {
  return (
    <div style={{ position: 'relative', width: '100%', ...style }}>
      <i 
        className="fa-solid fa-magnifying-glass" 
        style={{
          position: 'absolute', 
          left: iconLeft, 
          top: iconTop, 
          transform: 'translateY(-50%)', 
          color: 'var(--text-secondary)', 
          fontSize: iconSize
        }}
      ></i>
      <input 
        className="input-field" 
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ paddingLeft: inputPaddingLeft, margin: 0, ...inputStyle }}
      />
    </div>
  );
};

export default SearchBar;